import { Overlay } from '@cleartax/wg-library-overlay';
import { Toster } from '@cleartax/wg-library-toast';
import * as ReactDOM from 'react-dom';
import { REDIRECTION_OVERLAY_ID } from '../../../config/constants';
import { getPageLoader } from './';

/**
 * Renders a redirection overlay component in #redirection-overlay
 *
 * @returns void
 */
export const triggerRedirectionOverLay = (toaster = true): void => {
  ReactDOM.render(
    <Overlay classNames="z-1000" isOverlay={true} onClick={() => {}}>
      {getPageLoader()}
    </Overlay>,
    document.getElementById(REDIRECTION_OVERLAY_ID)
  );
  if (toaster) Toster.Loader('Redirecting....');
};

export const wrapperRedirectionOverlay = (url: string, iterval: number) => {
  triggerRedirectionOverLay();
  if (window !== undefined && url) {
    setTimeout(() => {
      window.location.href = url;
    }, iterval);
  }
};
